var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg3 = function Svg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.142 13.554q.064-1.706 1.102-2.63Q14.284 10 16.063 10q1.181 0 2.016.414.85.415 1.275 1.132a3 3 0 0 1 .441 1.61q0 1.05-.52 1.72-.519.654-1.212.893v.064q.897.302 1.417 1.004.52.7.52 1.8 0 .99-.457 1.753-.441.75-1.307 1.18-.85.43-2.031.43-1.89 0-3.024-.94-1.118-.94-1.181-2.837h2.614q.015.702.394 1.116.378.398 1.102.398.615 0 .945-.35.347-.368.347-.957 0-.765-.489-1.1-.473-.35-1.527-.35h-.504v-2.215h.504q.803 0 1.291-.271.504-.287.504-1.004 0-.574-.315-.892-.315-.32-.866-.32-.598 0-.898.367-.283.367-.33.909z"
  })));
};
export default Svg3;